import ReducerRegistry from '../base/redux/ReducerRegistry';
import { CUSTOM_PANEL_CLOSE, CUSTOM_PANEL_OPEN, SET_CUSTOM_PANEL_ENABLED } from './actionTypes';
const DEFAULT_STATE = {
    enabled: false,
    isOpen: false
};
/**
 * Listen for actions that mutate the custom panel state.
 */
ReducerRegistry.register('features/custom-panel', (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case CUSTOM_PANEL_CLOSE:
            return {
                ...state,
                isOpen: false
            };
        case CUSTOM_PANEL_OPEN:
            return {
                ...state,
                isOpen: true
            };
        case SET_CUSTOM_PANEL_ENABLED:
            return {
                ...state,
                enabled: action.enabled
            };
        default:
            return state;
    }
});
